export default __webpack_public_path__ + "static/media/Secutec.0dbf5b91.png";